const FourBarSeparator = () => (
  <div className="four-bar-separator">
    <div className="four-bars">
      <span /><span /><span /><span />
    </div>
  </div>
);

export default FourBarSeparator;
